const localForage = require('localforage');
const { setLocalForageInstance } = require('expo-use-memory-value/storage');
setLocalForageInstance(
  localForage.createInstance({ name: 'com.soundersmusic.app' })
);
